module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "count",
    class: {
      'count_bottom': _vm.bottom
    }
  }, [(_vm.hasText) ? _c('div', {
    staticClass: "count__text"
  }, [_vm._v(_vm._s(_vm.text))]) : _vm._e(), _c('Select', {
    attrs: {
      "name": _vm.name,
      "options": _vm.options,
      "placeholder": _vm.placeholder,
      "value": _vm.value
    },
    on: {
      "input": _vm.onInput
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35d1c5b6","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/components/selectcount/SelectCount.vue
// module id = 592fcd50efcb5af7fa30
// module chunks = 89